module.exports = __webpack_public_path__ + "assets/img/more-btn-697d7c28.png";